import { trpc } from "#/lib/trpc/client"
import { useQuery, type UseQueryResult } from "@tanstack/react-query"

// Shared so the upload mutation can update this cached status on success (see useUploadIdDocuments).
export const photoIdOnFileQueryKey = ["telemedicine", "getPhotoIdOnFile"]

type PhotoIdOnFileData = Awaited<ReturnType<typeof trpc.telemedicine.getPhotoIdOnFile.query>>

export function usePhotoIdOnFile(enabled: boolean): UseQueryResult<PhotoIdOnFileData> {
  return useQuery({
    queryKey: photoIdOnFileQueryKey,
    queryFn: () => trpc.telemedicine.getPhotoIdOnFile.query(),
    enabled,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  })
}
